import './DataList.scss';
import { useDataList } from './useDataListVM';
import { Collapsible } from 'components/Collapsible/Collapsible';
import Table from 'components/Table/Table';
import { createColumnHelper } from '@tanstack/react-table';
import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { Formik } from 'formik';
import * as Yup from 'yup';
import editIcon from 'assets/images/icons/edit.svg';
import trashIcon from 'assets/images/icons/trashcan.svg';
import plusIcon from 'assets/images/icons/plus.svg';

const DatalistItemSchema = Yup.object().shape({
    label: Yup.string().required('Le nom est requis')
});

export const DataList = () => {
    const {
        datalists,
        dataListItemToEdit,
        isModalOpen,
        setIsModalOpen,
        modalMode,
        handleEditItem,
        handleDeleteItem,
        handleUpdateItem,
        handleDeleteItemConfirm,
        handleModalTitle,
        handleModalYesText,
        handleAddItem,
        handleCreateItem,
    } = useDataList();

    const columnHelper = createColumnHelper<{ id: number, label: string }>();

    const getTableColumns = () => {
        return [
            columnHelper.accessor('label', {
                header: 'Label',
                cell: (info) => <i>{info.getValue()}</i>,
                footer: (info) => info.column.id,
                size: 1000
            }),
        
            columnHelper.display({
                header: 'Actions',
                cell: ({ row: { original: currRow } }) => {
                    return (
                        <span style={{ display: 'flex', columnGap: 12, justifyContent: 'flex-end' }}>
                            <Button
                                variant="light"
                                iconBefore
                                icon={<img src={editIcon} alt="Modifier" />}
                                callback={() => handleEditItem(currRow)}
                            />
                            <Button
                                variant="light"
                                iconBefore
                                icon={<img src={trashIcon} alt="Supprimer" />}
                                callback={() => handleDeleteItem(currRow)}
                            />
                        </span>
                    );
                },
                size: 100,
                enableSorting: false,
                id: 'actions'
            })
        ];
    };

    const EXCLUDE_DATALISTS = ['departments', 'roles', 'agenda_colors', 'partner_partners'];

    const DATALISTS_TRADUCTIONS = {
        //person_genres: 'Genres des personnes soutenues',
        //person_sources: 'Sources des personnes',
        //stakeholder_status: 'Statuts des proches',
        //disorders: 'Caractéristiques des personnes soutenues',
        //partner_sources: 'Sources des partenaires',
        //partner_targets: 'Cibles des partenaires',
        //partner_actions: 'Actions des partenaires',
        //communication_types: 'Types de communications',
        //event_types: 'Types d\'événements'
    };


    const DATALISTS_DATA = [
        {
            "label": "Personnes soutenues",
            "lists": [
                {
                    "id": "person_genres",
                    "label": "Genres des personnes soutenues"
                },
                {
                    "id": "person_sources",
                    "label": "Sources des personnes"
                },
                {
                    "id": "disorders",
                    "label": "Caractéristiques des personnes soutenues"
                },
                {
                    "id": "stakeholder_status",
                    "label": "Statuts des proches"
                },
                {
                    "id": "communication_types",
                    "label": "Types de communications des demandes RDV"
                },
                {
                    "id": "person_outgoing_reasons",
                    "label": "Raisons de sortie des personnes soutenues"
                }
            ]
        },
        {
            "label": "Partenaires",
            "lists": [
                {
                    "id": "partner_sources",
                    "label": "Sources des partenaires"
                },
                {
                    "id": "partner_targets",
                    "label": "Cibles des partenaires"
                },
                {
                    "id": "partner_actions",
                    "label": "Actions des partenaires"
                }
            ]
        },
        {
            "label": "APPV",
            "lists": [
                {
                    "id": "event_types",
                    "label": "Types d'événements AGENDA"
                }
            ]
        }
    ]
    console.log(datalists);

    return (
        <>
            <main id="settings-datalist">

                {datalists && DATALISTS_DATA.map((datalist, index) => {
                    return (
                        <div key={`${index}-group`}>
                            <h2 className="mb-small mt-large">{datalist.label}</h2>
                            {datalist.lists.map((list, index) => {
                                return (
                                <Collapsible
                                    key={`${index}-list`}
                                    className="mb-small"
                                    title={list.label}
                                    isInside
                                    >
                                        <Button
                                            variant="light"
                                            label="Ajouter un élément"
                                            iconBefore
                                            icon={<img src={plusIcon} alt="Ajouter" />}
                                            callback={() => handleAddItem(list.id)}
                                        />
                                        {!!Object.entries(datalists[list.id]).length 
                                        && <Table data={Object.entries(datalists[list.id]).map(([id, label]) => ({ id: parseInt(id), label }))}
                                            columns={getTableColumns()}
                                            columnHelper={columnHelper}
                                            className="table-card"
                                        />}
                                    </Collapsible>
                                );
                            })}
                        </div>
                    )
                })}


                {/*datalists && Object.keys(datalists)
                    .filter((datalist: string) => !EXCLUDE_DATALISTS.includes(datalist))
                    .map((datalist: string, index: number) => {
                        return (
                            <Collapsible
                                key={index}
                                className="mb-small"
                                title={DATALISTS_TRADUCTIONS[datalist as keyof typeof DATALISTS_TRADUCTIONS]}
                                isOpen={index === 0}
                                isInside
                            >
                                <Button
                                    variant="light"
                                    label="Ajouter un élément"
                                    iconBefore
                                    icon={<img src={plusIcon} alt="Ajouter" />}
                                    callback={() => handleAddItem(datalist)}
                                />
                                {!!Object.entries(datalists[datalist]).length 
                                && <Table data={Object.entries(datalists[datalist]).map(([id, label]) => ({ id: parseInt(id), label }))}
                                      columns={getTableColumns()}
                                      columnHelper={columnHelper}
                                      className="table-card"
                                />}
                            </Collapsible>
                        );
                    })*/}
            </main>

            <Modal
                open={isModalOpen}
                setClose={() => setIsModalOpen(false)}
                title={handleModalTitle()}
                yesText={handleModalYesText()}
                noText="Annuler"
                onClose={() => {
                    setIsModalOpen(false);
                }}
                formId={modalMode !== 'delete' ? "dataListItemForm" : undefined}
                isValidateSubmit={modalMode !== 'delete'}
                onValidate={() => {
                    if (modalMode === 'delete') {
                        handleDeleteItemConfirm();
                    } else {
                        document
                            .getElementById('dataListItemForm')
                            ?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }
                }}
            >
                {modalMode === 'delete' ? (
                    <div>
                        <p>Voulez-vous vraiment supprimer cet élément ?</p>
                    </div>
                ) : (
                    <Formik
                        initialValues={{
                            label: modalMode === 'edit' ? dataListItemToEdit?.label || '' : ''
                        }}
                        enableReinitialize={true}
                        validationSchema={DatalistItemSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            if (modalMode === 'edit') {
                                await handleUpdateItem(values.label);
                            } else {
                                await handleCreateItem(values.label);
                            }
                            setSubmitting(false);
                        }}
                    >
                        {(props) => (
                            <form id="dataListItemForm" onSubmit={props.handleSubmit} noValidate>
                                <div className="form">
                                    <div className="form-line">
                                        <div className="form-group">
                                            <label>Label</label>
                                            <input
                                                type="text"
                                                name="label"
                                                placeholder="Nom de l'élément"
                                                onChange={props.handleChange}
                                                value={props.values.label}
                                            />
                                            {props.errors.label && props.touched.label && (
                                                <p className="error">{String(props.errors.label)}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                )}
            </Modal>
        </>
    );
};
